import { useFormatMessage } from 'common/hooks/useFormatMessage';
import { WrappedLanguageControl } from 'common/organisms/WrappedLanguageControl';
import { LoginForm } from 'common/organisms/LoginForm';
import { Formik } from 'formik';
import * as React from 'react';

import { object, string } from 'yup';
import { Footer } from 'common/components/Footer';
import { PublicContainer } from 'common/components/PublicContainer';

export interface LoginTemplateProps {
  loading: boolean;
  onSubmit: (payload: { username: string; password: string }) => void;
}

export const LoginTemplate: React.FC<LoginTemplateProps> = ({
  loading,
  onSubmit,
}) => {
  const intlMessage = useFormatMessage();

  const loginFormValidationSchema = object().shape({
    username: string().required(
      intlMessage(
        {
          id: 'validation.required',
        },
        {
          field: intlMessage({ id: 'auth.username' }),
        }
      )
    ),
    password: string().required(
      intlMessage(
        {
          id: 'validation.required',
        },
        {
          field: intlMessage({ id: 'auth.password' }),
        }
      )
    ),
  });

  return (
    <>
      <PublicContainer>
        <WrappedLanguageControl />
        <Formik
          initialValues={{ username: '', password: '' }}
          onSubmit={onSubmit}
          validationSchema={loginFormValidationSchema}
        >
          {(formikProps) => <LoginForm {...formikProps} loading={loading} />}
        </Formik>
      </PublicContainer>
      <Footer />
    </>
  );
};
